/*

DATE SORTER

V1 - 2023-10-24

----- USAGE -----

Send this function the following:

  OBJECT:
  {
    id: // unique key, i.e. the iteration
    value: // the value to sort by
  }
  STRING: asc || desc

It will return an OBJECT in order dictated by the STRING given

*/

function arraySorter(object: any, sortBy: 'asc' | 'desc') {
  let returnObj

  if (sortBy === 'asc') {
    returnObj = object.sort((one: any, two: any) => {
      if (one.date > two.date)
        return 1
      else
        return -1
    })
  }
  else if (sortBy === 'desc') {
    returnObj = object.sort((one: any, two: any) => {
      if (one.date > two.date)
        return 1
      else
        return -1
    })
  }

  return returnObj
}

export default arraySorter
